// Modelled on Hedge-Fund-Tracking-System apps/web/src/lib/route-guard.tsx.
// We don't have per-role route maps (single-user app), so this is a slim
// "is the user authenticated?" wrapper that surfaces the loading and error
// states with the same look as the rest of the dashboard.
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';

export function RouteGuard({ children }: { children: ReactNode }) {
  const { user, isLoading, isError } = useAuth();
  const loc = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="text-sm text-muted-foreground animate-pulse">Loading…</p>
      </div>
    );
  }

  if (isError || !user) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }

  return <>{children}</>;
}
